<template>
  <div class="template">
    <div class="search">
      <div class="search-center">
        <div class="search-item">
          门店名称：
          <Input clearable v-model="search.storeName" placeholder="请输入门店名称" style="width: 150px; margin-left: 10px"></Input>
        </div>
        <div class="search-item">
          联系人：
          <Input clearable v-model="search.contactPerson" placeholder="请输入联系人" style="width: 120px; margin-left: 10px"></Input>
        </div>
        <div class="search-item">
          状态：
          <Select clearable v-model="search.status" placeholder="请选择" style="width: 120px; margin-left: 10px">
            <Option value="0">正常</Option>
            <Option value="1">停用</Option>
          </Select>
        </div>
        <Button style="width: 80px; margin-right: 10px" type="primary" icon="ios-search" @click="searchFn">查询</Button>
        <Button style="width: 80px" @click="clearFn">重置</Button>
      </div>
    </div>
    
    <div class="filter">
      <div class="filter-center">
        <Button style="margin-right: 10px" type="primary" icon="ios-add" @click="handleAdd">新增</Button>
        <Button style="margin-right: 10px" type="error" icon="ios-trash" @click="handleDelete" :disabled="selections.length === 0">删除</Button>
      </div>
    </div>

    <div class="table">
      <Table :columns="columns" :data="tableList" @on-selection-change="handleSelectionChange">
        <template slot-scope="{ row }" slot="status">
          <Tag :color="row.status === '0' ? 'success' : 'default'">{{ row.status === '0' ? '正常' : '停用' }}</Tag>
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button type="primary" size="small" @click="handleEdit(row)">编辑</Button>
        </template>
      </Table>
      <Page
        :total="total"
        show-total
        :page-size="search.limit"
        :current="search.page"
        :page-size-opts="[10, 20, 30, 50]"
        @on-change="pageChange"
        @on-page-size-change="limitChange"
        class-name="footer-page"
        show-elevator
        show-sizer
        placement="top"
        style="margin-top: 10px; text-align: right;"
      ></Page>
    </div>

    <!-- 新增/编辑对话框 -->
    <Modal v-model="modalVisible" :title="modalTitle" width="700" @on-ok="handleSubmit" @on-cancel="handleCancel">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <FormItem label="门店名称" prop="storeName">
          <Input v-model="formValidate.storeName" placeholder="请输入门店名称" />
        </FormItem>
        <FormItem label="联系人" prop="contactPerson">
          <Input v-model="formValidate.contactPerson" placeholder="请输入联系人" />
        </FormItem>
        <FormItem label="联系电话" prop="contactPhone">
          <Input v-model="formValidate.contactPhone" placeholder="请输入联系电话" />
        </FormItem>
        <FormItem label="详细地址" prop="address">
          <Input v-model="formValidate.address" type="textarea" :rows="3" placeholder="请输入详细地址" />
        </FormItem>
        <FormItem label="状态" prop="status">
          <RadioGroup v-model="formValidate.status">
            <Radio label="0">正常</Radio>
            <Radio label="1">停用</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="formValidate.remark" type="textarea" :rows="4" placeholder="请输入备注" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { storeList, addStore, updateStore, delStore } from '@/api/franchise-store.js'

export default {
  name: 'franchise-store',
  data() {
    return {
      search: {
        storeName: '',
        contactPerson: '',
        contactPhone: '',
        status: '',
        page: 1,
        limit: 10
      },
      columns: [
        { type: 'selection', width: 60, align: 'center' },
        { title: '门店ID', key: 'storeId', width: 100 },
        { title: '门店名称', key: 'storeName', minWidth: 150 },
        { title: '联系人', key: 'contactPerson', width: 120 },
        { title: '联系电话', key: 'contactPhone', width: 130 },
        { title: '地址', key: 'address', minWidth: 200, ellipsis: true, tooltip: true },
        { title: '状态', slot: 'status', width: 100 },
        { title: '操作', slot: 'action', width: 100, fixed: 'right' }
      ],
      tableList: [],
      total: 0,
      selections: [],
      modalVisible: false,
      modalTitle: '',
      isEdit: false,
      formValidate: {
        storeId: null,
        storeName: '',
        contactPerson: '',
        contactPhone: '',
        address: '',
        status: '0',
        remark: ''
      },
      ruleValidate: {
        storeName: [{ required: true, message: '门店名称不能为空', trigger: 'blur' }],
        contactPhone: [
          { required: true, message: '联系电话不能为空', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      storeList(this.search).then(res => {
        const page = res.data.page
        this.tableList = page.records || []
        this.total = page.total || 0
      })
    },
    searchFn() {
      this.search.page = 1
      this.getList()
    },
    clearFn() {
      this.search = {
        storeName: '',
        contactPerson: '',
        contactPhone: '',
        status: '',
        page: 1,
        limit: 10
      }
      this.getList()
    },
    handleAdd() {
      this.modalTitle = '新增门店'
      this.isEdit = false
      this.formValidate = {
        storeId: null,
        storeName: '',
        contactPerson: '',
        contactPhone: '',
        address: '',
        status: '0',
        remark: ''
      }
      this.modalVisible = true
      this.$nextTick(() => {
        this.$refs.formValidate && this.$refs.formValidate.resetFields()
      })
    },
    handleEdit(row) {
      this.modalTitle = '编辑门店'
      this.isEdit = true
      this.formValidate = { ...row }
      this.modalVisible = true
    },
    handleSubmit() {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          const api = this.isEdit ? updateStore : addStore
          api(this.formValidate).then(() => {
            this.$Message.success(this.isEdit ? '修改成功' : '新增成功')
            this.modalVisible = false
            this.getList()
          })
        }
      })
    },
    handleCancel() {
      this.modalVisible = false
    },
    handleSelectionChange(selection) {
      this.selections = selection
    },
    handleDelete() {
      const ids = this.selections.map(item => item.storeId)
      this.$Modal.confirm({
        title: '提示',
        content: `确定要删除选中的 ${ids.length} 条数据吗?`,
        onOk: () => {
          delStore(ids).then(() => {
            this.$Message.success('删除成功')
            this.getList()
          })
        }
      })
    },
    pageChange(page) {
      this.search.page = page
      this.getList()
    },
    limitChange(limit) {
      this.search.limit = limit
      this.search.page = 1
      this.getList()
    }
  }
}
</script>

<style scoped lang="less">
</style>
